import { useEffect, useRef } from 'react';
import { usePage } from '@inertiajs/react';
import { useSnackbar } from 'notistack';

interface Flash {
  alert?: string;
  notice?: string;
}

interface PageProps {
  flash?: Flash;
  [key: string]: unknown;
}

// Shows a toast for any flash message shared by the backend via `inertia_share`
// (see Web::BaseController). Mounted once in the shared Layout, so it works
// regardless of which page the user lands on.
export const FlashToast = () => {
  const { props } = usePage<PageProps>();
  const { enqueueSnackbar } = useSnackbar();
  const lastShown = useRef<string | null>(null);

  useEffect(() => {
    const { alert, notice } = props.flash || {};
    const message = alert || notice;
    if (!message || message === lastShown.current) return;

    lastShown.current = message;
    enqueueSnackbar(message, { variant: alert ? 'error' : 'success' });
  }, [props.flash, enqueueSnackbar]);

  return null;
};
